import {
  ButtonList,
  DropdownButton,
  FlexBox,
  IconButton,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { ampli } from 'lib-shared-tracking';

import style from './style.module.scss';

export type ActionsMenuProps = {
  readonly onRename: () => void;
  readonly onDelete: () => void;
  readonly onDuplicateMessenger: () => void;
  readonly onEditFlow: () => void;
  readonly onAudit: () => void;
  readonly onEditSettings: () => void;
};

export function ActionsMenu({
  onRename,
  onDuplicateMessenger,
  onDelete,
  onEditFlow,
  onAudit,
  onEditSettings,
}: ActionsMenuProps): JSX.Element {
  const hasChannelSetupAccess = useHasAccess(
    'settings.integration.channel.setup',
  );
  const hasChannelEditAccess = useHasAccess(
    'settings.integration.channel.edit',
  );
  const hasFlowReadAccess = useHasAccess('settings.flow:r');
  const hasFlowWriteAccess = useHasAccess('settings.flow:w');

  const menuToggleOnClick = (isOpen: boolean) => {
    if (isOpen) {
      ampli.messengerOptionsMenuOpened();
    }
  };

  return (
    <FlexBox gap="50" alignItems="center" justifyContent="flex-end">
      {hasFlowReadAccess && (
        <Tooltip content="Edit flow">
          <IconButton icon="flow" variant="tertiary" onClick={onEditFlow} />
        </Tooltip>
      )}

      {hasChannelEditAccess && (
        <Tooltip content="Setup">
          <IconButton icon="cog" variant="tertiary" onClick={onEditSettings} />
        </Tooltip>
      )}

      <DropdownButton
        icon="dots-h"
        fixed
        buttonProps={{ variant: 'tertiary' }}
        onToggle={menuToggleOnClick}
        noArrow
        dropdown={
          <ButtonList>
            {hasFlowWriteAccess && hasChannelSetupAccess && (
              <ButtonList.Item onClick={onDuplicateMessenger}>
                Duplicate
              </ButtonList.Item>
            )}

            {hasChannelEditAccess && (
              <ButtonList.Item onClick={onRename}>Rename</ButtonList.Item>
            )}

            {hasFlowReadAccess && (
              <ButtonList.Item onClick={onAudit}>See audit log</ButtonList.Item>
            )}

            {hasChannelSetupAccess && (
              <>
                <ButtonList.Divider />
                <ButtonList.Item
                  onClick={onDelete}
                  buttonClassName={style.deleteButton}
                >
                  Delete
                </ButtonList.Item>
              </>
            )}
          </ButtonList>
        }
      />
    </FlexBox>
  );
}
